import { render, staticRenderFns } from "./FormBuilderPhotoForm.vue?vue&type=template&id=c1a1cca8&"
import script from "./FormBuilderPhotoForm.vue?vue&type=script&lang=js&"
export * from "./FormBuilderPhotoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports